import React from 'react';
import styled from "styled-components";
import Carousel from '../Carousel';

const Section = styled.section`
    min-height: 100vh;
    width: 100%;
    background-color: ${props => props.theme.text};

    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`

const Container = styled.div`
    width: 75%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 70em) {
        width: 85%;
    }

    @media (max-width: 64em) {
        width: 100%;
        flex-direction: column;

        &>*:last-child {
            width: 80%;
        }
    }


    @media (max-width: 40em) {
        &>*:last-child {
            width: 90%;
        }
    }
`

const Box = styled.div`
    width: 50%;
    height: 100%;
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 40em) {
        min-height: 60vh;
    }
`

const Title = styled.h2`
    font-family: 'Sora', cursive;
    font-size: ${props => props.theme.fontxxl};
    text-transform: capitalize;
    color: ${props => props.theme.body};
    width: 80%;
    margin: 0 auto;

    @media (max-width: 64em) {
        width: 100%;
        text-align: center;
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontxl};
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontlg};
    }
`

const SubText = styled.p`
    font-size: ${props => props.theme.fontlg};
    color: ${props => props.theme.body};
    align-self: flex-start;
    width: 80%;
    margin: 1rem auto;
    font-weight: 400;

    @media (max-width: 64em) {
        width: 100%;
        text-align: center;
        font-size: ${props => props.theme.fontmd};
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontxl};
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontlg};
    }
`

const SubTextLight = styled.p`
    font-size: ${props => props.theme.fontlg};
    color: ${(props) => `rgba(${props.theme.bodyRgba}, 0.6)`};
    align-self: flex-start;
    width: 80%;
    margin: 1rem auto;
    font-weight: 400;

    @media (max-width: 64em) {
        width: 100%;
        text-align: center;
        font-size: ${props => props.theme.fontsm};
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontsm};
    }

    @media (max-width: 40em) {
        font-size: ${props => props.theme.fontxs};
    }
`
const About = () => {
    return (
        <Section id="about">
            <Container>
                <Box> <Carousel /> </Box>
                <Box>
                    <Title>
                        Welcome to JollyShow
                    </Title>
                    <SubText>
                        JollyShow is partenering with Bubblehouse to bring to you unique digital NFTs
                    </SubText>
                    <SubTextLight>
                        With more than 100+ hand drawn traits, each NFT is unique and comes with a membership to an exclusive group.
                    </SubTextLight>
                </Box>
            </Container>

        </Section>
    )
}
export default About;